import * as React from "react";
import {CardButton} from "components/dashboard/CardButton";
import "./AccountNavCard.pcss";
import {AccountSubContainer} from "components/account/widgets/AccountSubContainer";

interface Props {
  title:string;
  titleNotBold?:string;
  subTitle:string;
  buttonAction?:()=>void;
  buttonLabel?:string;
  buttonVariant?:'standard'|'outlined';
  buttonHideArrow?:boolean;
  description?:string;
  icon?:React.ReactNode;

}

export const AccountNavCard = (props:Props) =>
 <AccountSubContainer className="profile-nav-card">
   <div className="pnc-main">
     {props.icon && <div className={"pnc-icon"}>{props.icon}</div>}
     <div className={"pnc-main-body"}>
       <h3><strong>{props.title}</strong>{props.titleNotBold}</h3>
       <p>{props.subTitle}</p>
     </div>
     {props.buttonAction &&
     <div className={"pnc-action"}>
       <CardButton variant={props.buttonVariant} buttonAction={props.buttonAction} buttonLabel={props.buttonLabel} hideLabel={!props.buttonLabel} hideArrow={props.buttonHideArrow} />
     </div>
     }
   </div>
   {props.description && <p className={"pnc-description"}>{props.description}</p>}
 </AccountSubContainer>
;
